import type { RemuneracaoModelo } from "@/types/api";

export interface ConversionPreview {
  valorBruto: number;
  descontoValor: number;
  remuneracaoValor: number;
  valorLiquido: number;
}

/**
 * Mirrors the backend conversion_calculator.py logic.
 * Formula:
 *   desconto_valor = valor_bruto * desconto_pct / 100
 *   remuneracao_valor = valor_bruto * remuneracao_valor / 100  (percentual)
 *   remuneracao_valor = remuneracao_valor                      (fixo)
 */
export function calcularConversao(
  valorBruto: number,
  remuneracaoModelo: RemuneracaoModelo,
  remuneracaoValor: number,
  descontoPct: number | null
): ConversionPreview {
  const descontoValor = descontoPct != null ? round2(valorBruto * descontoPct / 100) : 0;

  const remuneracao =
    remuneracaoModelo === "percentual"
      ? round2(valorBruto * remuneracaoValor / 100)
      : round2(remuneracaoValor);

  return {
    valorBruto: round2(valorBruto),
    descontoValor,
    remuneracaoValor: remuneracao,
    valorLiquido: round2(valorBruto - descontoValor),
  };
}

function round2(n: number): number {
  return Math.round(n * 100) / 100;
}
